import React from 'react'
import Innerbanner from '../components/Innerbanner';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import Row from 'react-bootstrap/Row';
import Tab from 'react-bootstrap/Tab';
import Header from '../components/Header/Header';
import Talentcategory from '../components/TalentProfile/Talentcategory';
import Talentinfo from '../components/TalentProfile/Talentinfo';
import Experience from '../components/TalentProfile/Experience';
import Technology from '../components/TalentProfile/Technology';
import Hireinginfo from '../components/TalentProfile/Hireinginfo';
import Candidprofile from '../components/TalentProfile/Candidprofile';


function TalentProfile() {

    const talent_profile_wrapper={ 
        height:'100vh',
        width:'100%',
        overflowY:'scroll'
        };

  return (
    <>
    <Header/>
    <Innerbanner/>
    <div className='talent_profile_wrapper' style={talent_profile_wrapper}>
        <Container>
            <h4>Talent Profile</h4>
            <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                <Row>
                <Col sm={3}>          
                    <Nav variant="pills" className="flex-column">
                        <Nav.Item>
                            <Nav.Link eventKey="first">
                            <Candidprofile/>                  
                            </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="second">
                            <Candidprofile/>
                            </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="third">
                                <Candidprofile/>                
                            </Nav.Link>
                        </Nav.Item>
                    </Nav>
                </Col>
                <Col sm={9}>
                    <Tab.Content>
                        <Tab.Pane eventKey="first">
                            <Talentcategory/>                
                            <Talentinfo/>                        
                            <Experience/>                
                            <Technology/>               
                            <Hireinginfo/>                        
                        </Tab.Pane>
                        <Tab.Pane eventKey="second">
                            <Talentcategory/>                
                            <Talentinfo/>                        
                            <Experience/>                
                            <Technology/>               
                            <Hireinginfo/>
                        </Tab.Pane>
                        <Tab.Pane eventKey="third">
                            <Talentcategory/>                
                            <Talentinfo/>                        
                            <Experience/>                
                            <Technology/>               
                            <Hireinginfo/>
                        </Tab.Pane>
                    </Tab.Content>
                </Col>
                </Row>
            </Tab.Container>
        </Container>
    </div>
  </>
  )
}

export default TalentProfile